import { Icon, Spinner } from '@/src/components/ui';
import { Button } from '@workspace/ui/components/button';
import React from 'react';
import { EPublicationStatus } from 'types/src/types';

export const PublishStatusBadge = ({
  status,
  children,
  purchased,
  isMyProject,
}: {
  status?: EPublicationStatus;
  children?: React.ReactNode;
  purchased?: boolean;
  isMyProject: boolean;
}) => {
  return (
    <div className="flex gap-3 items-center">
      {children}
      {isMyProject ? (
        status !== EPublicationStatus.APPROVED ? (
          <>
            <hr className="border-r border-gray-200 h-5" />
            {status === EPublicationStatus.PENDING && (
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1 text-blue-primary text-xs p-1 border rounded-sm border-blue-primary">
                  <Spinner /> Safety check in progress
                </div>
                <hr className="border-r border-gray-200 h-5" />
                <Button
                  size="icon"
                  onClick={() => window.location.reload()}
                  variant="ghost"
                  className="text-xs! p-1! w-fit font-light!"
                >
                  <Icon name="reload" className="size-4 text-black" /> Refresh
                  page
                </Button>
              </div>
            )}
            {status === EPublicationStatus.REJECTED && (
              <div className="flex items-center gap-1 p-1 border rounded-sm border-red-error text-red-error text-xs">
                <Icon name="report" className="text-red-error size-3" />
                File Unsafe
              </div>
            )}
            {status === EPublicationStatus.ERROR && (
              <div className="flex items-center gap-1 text-xs p-1 border rounded-sm border-orange-300 text-orange-400">
                Scan Failed
              </div>
            )}
          </>
        ) : (
          <>
            <hr className="border-r border-gray-200 h-5" />
            <div className="flex items-center gap-1 text-xs p-1 border rounded-sm border-green-primary text-green-primary">
              Published
            </div>
          </>
        )
      ) : purchased ? (
        <>
          <hr className="border-r border-gray-200 h-5" />
          <div className="flex items-center gap-1 text-xs p-1 border rounded-sm border-blue-primary text-blue-primary">
            Purchased
          </div>
        </>
      ) : null}
    </div>
  );
};
